import { render, staticRenderFns } from "./IndoorSettingView.vue?vue&type=template&id=b85e4986&scoped=true&"
import script from "./IndoorSettingView.vue?vue&type=script&lang=js&"
export * from "./IndoorSettingView.vue?vue&type=script&lang=js&"
import style0 from "./IndoorSettingView.vue?vue&type=style&index=0&id=b85e4986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85e4986",
  null
  
)

export default component.exports